import { assign } from "lodash";
import {
  QUERY_FUNDING_REQUEST_REQUEST,
  QUERY_FUNDING_REQUEST_SUCCESS,
  QUERY_FUNDING_REQUEST_FAILURE
} from "../types";

// const sameRequest = (state, payload) =>
//   state.status === payload.status &&
//   state.limit === payload.limit &&
//   state.offset === payload.offset &&
//   state.ordering === payload.ordering;

export default (
  state = {
    members: {
      loading: false,
      ids: []
    }
  },
  action
) => {
  switch (action.type) {
    case QUERY_FUNDING_REQUEST_REQUEST:
      return {
        ...state,
        fundingRequests: assign({}, state.fundingRequests, {
          ids: [],
          loading: true
          // status: action.payload.status,
          // limit: action.payload.limit,
          // offset: action.payload.offset,
          // ordering: action.payload.ordering,
          // filters: action.payload.filters
        })
      };
    case QUERY_FUNDING_REQUEST_SUCCESS:
      // if (sameRequest(state, action.payload)) {
      return {
        fundingRequests: assign({}, state.fundingRequests, {
          loading: false,
          id: action.payload.id,
          ids: action.payload.items,
          count: action.payload.count,
          next: action.payload.next,
          previous: action.payload.previous
        })
      };
    // }
    // return state;
    case QUERY_FUNDING_REQUEST_FAILURE:
      return {
        fundingRequests: assign({}, state.fundingRequests, {
          loading: false
        })
      };
    // return state;
    default:
      return state;
  }
};
